/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_ReferralInputs */

const en_plan_referral = /** @type {(inputs: Plan_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral`)
};

const es_plan_referral = /** @type {(inputs: Plan_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referido`)
};

/**
* | output |
* | --- |
* | "Referral" |
*
* @param {Plan_ReferralInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_referral = /** @type {((inputs?: Plan_ReferralInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_ReferralInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_referral(inputs)
	return en_plan_referral(inputs)
});